__turbopack_export_value__({
  "articles": "Articles-module-scss-module__ZrfPiq__articles",
  "articles__list": "Articles-module-scss-module__ZrfPiq__articles__list",
  "articles__pagination": "Articles-module-scss-module__ZrfPiq__articles__pagination",
  "articles__showMore": "Articles-module-scss-module__ZrfPiq__articles__showMore",
  "body-logo-18": "Articles-module-scss-module__ZrfPiq__body-logo-18",
  "body-text-12": "Articles-module-scss-module__ZrfPiq__body-text-12",
  "body-text-14": "Articles-module-scss-module__ZrfPiq__body-text-14",
  "body-text-16": "Articles-module-scss-module__ZrfPiq__body-text-16",
  "body-text-18": "Articles-module-scss-module__ZrfPiq__body-text-18",
  "body-text-20": "Articles-module-scss-module__ZrfPiq__body-text-20",
  "body-text-24": "Articles-module-scss-module__ZrfPiq__body-text-24",
  "body-text-24-2": "Articles-module-scss-module__ZrfPiq__body-text-24-2",
  "body-text-heading-2": "Articles-module-scss-module__ZrfPiq__body-text-heading-2",
  "body-text-heading-3": "Articles-module-scss-module__ZrfPiq__body-text-heading-3",
  "body-text-medium-14": "Articles-module-scss-module__ZrfPiq__body-text-medium-14",
  "body-text-medium-16": "Articles-module-scss-module__ZrfPiq__body-text-medium-16",
  "body-text-medium-18": "Articles-module-scss-module__ZrfPiq__body-text-medium-18",
  "body-text-medium2-18": "Articles-module-scss-module__ZrfPiq__body-text-medium2-18",
  "body-text2-14": "Articles-module-scss-module__ZrfPiq__body-text2-14",
  "body-text2-16": "Articles-module-scss-module__ZrfPiq__body-text2-16",
  "button-primary-text": "Articles-module-scss-module__ZrfPiq__button-primary-text",
  "button-text": "Articles-module-scss-module__ZrfPiq__button-text",
  "button2-text": "Articles-module-scss-module__ZrfPiq__button2-text",
  "card-shadow": "Articles-module-scss-module__ZrfPiq__card-shadow",
  "effect-menu": "Articles-module-scss-module__ZrfPiq__effect-menu",
  "header-1": "Articles-module-scss-module__ZrfPiq__header-1",
  "main-container": "Articles-module-scss-module__ZrfPiq__main-container",
  "main-footer-container": "Articles-module-scss-module__ZrfPiq__main-footer-container",
  "main-header-container": "Articles-module-scss-module__ZrfPiq__main-header-container",
  "txt-12-bold": "Articles-module-scss-module__ZrfPiq__txt-12-bold",
  "txt-14-bold": "Articles-module-scss-module__ZrfPiq__txt-14-bold",
  "txt-14-bold-caps": "Articles-module-scss-module__ZrfPiq__txt-14-bold-caps",
  "txt-14-med": "Articles-module-scss-module__ZrfPiq__txt-14-med",
  "txt-16-bold": "Articles-module-scss-module__ZrfPiq__txt-16-bold",
  "txt-16-med": "Articles-module-scss-module__ZrfPiq__txt-16-med",
  "txt-18-bold": "Articles-module-scss-module__ZrfPiq__txt-18-bold",
  "txt-18-medium": "Articles-module-scss-module__ZrfPiq__txt-18-medium",
  "txt-18-medium-24": "Articles-module-scss-module__ZrfPiq__txt-18-medium-24",
  "txt-24-semi": "Articles-module-scss-module__ZrfPiq__txt-24-semi",
});
